export default __webpack_public_path__ + "static/latitude-gem-debd820f0e842fc604d0d8d1ccbc1f85.png";